import Const from 'constants';

const stateDataStruct = {
    lineupsQuantity: 3,
    isResetAllowed: true,
};

const defaultState = {
    data: cp(stateDataStruct),
    isResetAllowed() {
        return this.data.isResetAllowed;
    },
    getLineupsQuantity() {
        return Number(this.data.lineupsQuantity);
    },
    isLineupsQuantityEqual(value) {
        return this.getLineupsQuantity() === Number(value);
    },
    getMinBoundary: () => 1,
    getMaxBoundary: () => Const.MAX_GENERATED_LINEUPS_QUANTITY,
};

export default function (state = defaultState, action) {
    if (action.type === Const.SET_LINEUPS_QUANTITY) {
        state = {...state};
        state.data.lineupsQuantity = action.value;
        if (action.hasOwnProperty('isResetAllowed')) {
            state.data.isResetAllowed = action.isResetAllowed;
        }
    } else if (action.type === Const.RESET_ALL_SETTINGS) {
        if (state.data.isResetAllowed) {
            state = {
                ...defaultState,
                data: cp(stateDataStruct),
            };
        }
    } else if (action.type === Const.FILTER_BY_SLATE) {
        state = {
            ...defaultState,
            data: cp(stateDataStruct),
        };
    }

    return state;
}
